import env from '@/utils/env.js';
import MainStore from '@/store/userStore';
import Native from '@/utils/nativeProxy';

class CustomError extends Error {
  constructor({
    message,
    response,
    error,
    serverError,
  }) {
    super(message);
    this.message = message;
    this.error = error;
    this.response = response;
    this.serverError = serverError;
    this.name = 'CustomError';
  }
}

// promise耗时过长抛错
function promiseTimeout({ promise, timeoutMsg = 'promise调用超时', timeout = 1000 } = {}) {
  return Promise.race([
    promise,
    new Promise((_res, rej) => {
      setTimeout(() => {
        rej(new CustomError({
          message: timeoutMsg,
          response: 'promise调用超时',
        }));
      }, timeout);
    }),
  ]);
}

// 相关文档 https://hellobike.yuque.com/tdku95/nmgtew/xw2fhvgpk8dhxnqe
function getDeviceFingerprintHash() {
  if (env.isEasyBikeApp || env.isHitchIndepApp) {
    // 担心app方法阻塞接口请求,设置超时1000
    return promiseTimeout({
      promise: Native.getDeviceFingerprintHash(),
      timeoutMsg: '获取DeviceHash失效',
      timeout: 1000,
    });
  }
  // 其他情况不考虑
  return Promise.resolve({});
}

export default async function getRiskParamFn() {
  const userInfo = MainStore.getUserStore() || {};
  try {
    const bridgeResult = await getDeviceFingerprintHash() || {};
    const deviceHash = bridgeResult['fingerprint-hash']
      || bridgeResult.fingerprintHash
      || '';

    console.warn('获取deviceHash成功', deviceHash);
    return {
      ...bridgeResult,
      deviceHash,
      deviceLon: userInfo.longitude || '',
      deviceLat: userInfo.latitude || '',
      systemCode: env.systemCode,
    };
  } catch (error) {
    console.warn('获取deviceHash失败', error);
    return {
      deviceHash: '',
      deviceLon: userInfo.longitude || '',
      deviceLat: userInfo.latitude || '',
      systemCode: env.systemCode,
    };
  }
}
